import {genericMandarkRequest} from 'resources/mandark.resource';

export interface CourseworkSyncResponse {
  body?: {
    data?: {
      attributes?: {
        synced?: boolean;
        google_coursework_id?: string | null;
      };
    };
  };
}

// raw: the endpoint returns a jsonapi-shaped envelope for a pseudo-resource;
// letting the framework ingest it would pollute the model cache.
const requestCourseworkSync = (
  method: 'post' | 'delete',
  classroomId: string,
  assignmentId: string
): Promise<CourseworkSyncResponse> => {
  return genericMandarkRequest(
    method,
    {
      resourcePath: ['google_classroom_api', 'coursework', classroomId, assignmentId]
    },
    {},
    {raw: true}
  ) as unknown as Promise<CourseworkSyncResponse>;
};

export const syncGoogleCourseworkQuery = (
  classroomId: string,
  assignmentId: string
): Promise<CourseworkSyncResponse> => {
  return requestCourseworkSync('post', classroomId, assignmentId);
};

export const unsyncGoogleCourseworkQuery = (
  classroomId: string,
  assignmentId: string
): Promise<CourseworkSyncResponse> => {
  return requestCourseworkSync('delete', classroomId, assignmentId);
};
